import { Injectable } from '@angular/core';
import { ConnectedFieldModel } from '@seahorse/domain';
import { FormField } from '../form/form.model';

@Injectable({
  providedIn: 'root',
})
export class ConnectedFieldsService {
  private _selectedConnectedFields: ConnectedFieldModel[] = [];

  get selectedConnectedFields(): ConnectedFieldModel[] {
    return this._selectedConnectedFields;
  }

  hasSelectedFields(): boolean {
    return this._selectedConnectedFields.length > 0;
  }

  reset(): void {
    this._selectedConnectedFields = [];
  }

  collectFromForm(fields: FormField[]): void {
    if (!fields || fields.length === 0) {
      this._selectedConnectedFields = [];
      return;
    }

    this._selectedConnectedFields = fields
      .flatMap((field) => field.connectedFields || [])
      .filter((cf) => cf.selected !== false);
  }

  getAndClear(): ConnectedFieldModel[] | null {
    if (this._selectedConnectedFields.length === 0) {
      return null;
    }

    const fields = [...this._selectedConnectedFields];
    this.reset();
    return fields;
  }
}
